import { gql } from 'graphql-tag';

export const PAYBRIGHT_CHECKOUT = gql`
  query paybrightCheckout($inputData: PaybrightCheckoutInputType!) {
    paybrightCheckout(inputData: $inputData) {
      url
    }
  }
`;
